<template>
  <div class="collapse">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['autoBan'],
      }"
      @click="configMainShow['autoBan'] = !configMainShow['autoBan']"
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>自动封禁</span>
        <span class="el-switch" @click.stop="toggleEnable('autoBan', '自动封禁')">
          <el-switch v-model="configure.autoBan.enable" disabled></el-switch>
        </span>
      </div>
    </div>

    <div
      class="bd"
      @click="
        isNaN(featureList['autoBan'].timeRemaining)
          ? shoWDialogBuy(featureList['autoBan']['productKey'], '基础包', 'autoBan')
          : featureList['autoBan'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : configure.autoBan.enable
          ? ''
          : toggleEnable('autoBan', '自动禁言')
      "
      :class="{
        'no-buy': isNaN(featureList['autoBan'].timeRemaining),
        expired: featureList['autoBan'].timeRemaining <= 0,
        'shut-off': !configure.autoBan.enable,
      }"
    >
      <el-row>
        <el-col :span="5">昵称敏感词</el-col>
        <el-col :span="19">
          <div class="block-tag">
            昵称中带有以下敏感词的，机器人将不会欢迎、感谢及互动。
          </div>
          <div class="black-list">
            <div class="tag-editor">
              <div class="tag-editor-row">
                <el-tag
                  v-for="(ii, idx) in configure.blacklist.list"
                  :key="idx"
                  size="small"
                  closable
                  @close="removeTag(configure.blacklist.list, idx)"
                  type="info"
                  >{{ ii }}</el-tag
                >
                <input
                  type="text"
                  placeholder="输入完，按回车确认"
                  @blur="addTag(configure.blacklist.list, $event)"
                  @keyup.enter="addTag(configure.blacklist.list, $event)"
                />
              </div>
            </div>
          </div>
          <!-- <div class="row-padding">
            <el-switch v-model="configure.autoBan.cloudAutoBan"></el-switch
            >智能封禁（根据智能规则封禁广告号）
          </div> -->
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">弹幕敏感词</el-col>
        <el-col :span="19">
          <div class="block-tag el-tag--danger">
            弹幕中带有以下敏感词的，机器人将会执行你设置的封禁动作。
          </div>
          <div class="sentence-list">
            <ul v-if="configure.autoBan.rule && configure.autoBan.rule.length">
              <li v-for="(item, index) in configure.autoBan.rule" :key="index">
                <div class="tag-editor">
                  <div class="tag-editor-row">
                    <span class="hd">关键词：</span>
                    <el-tag
                      v-for="(ii, idx) in item.keywords"
                      :key="idx"
                      size="small"
                      closable
                      @close="removeTag(item.keywords, idx)"
                      >{{ ii }}</el-tag
                    >
                    <input
                      type="text"
                      placeholder="输入完，按回车确认"
                      @blur="addTag(item.keywords, $event)"
                      @keyup.enter="addTag(item.keywords, $event)"
                    />
                  </div>
                  <div class="tag-editor-row">
                    <span class="hd">封　禁：</span>
                    <el-cascader
                      size="mini"
                      v-model="item.tpl"
                      @change="(e) => banSelChange(e, item)"
                      :options="banOptions"
                      clearable
                    ></el-cascader>
                  </div>
                </div>
                <i class="fa-window-close" @click="removeAutoBanMsg(index)"></i>
              </li>
            </ul>
          </div>
          <div
            class="sentence-add"
            tabindex="99"
            @focusin="eleFocusIn('addautoBanMsgTpl')"
            @focusout="addautoBanMsgFocusOut"
          >
            <div class="tag-editor">
              <div class="tag-editor-row">
                <span class="hd">关键词：</span>
                <el-tag
                  v-for="(item, index) in addautoBanMsg.keywords"
                  :key="index"
                  size="small"
                  closable
                  @close="removeTag(addautoBanMsg.keywords, index)"
                  >{{ item }}</el-tag
                >
                <input
                  type="text"
                  placeholder="输入完，按回车确认"
                  @blur="addTag(addautoBanMsg.keywords, $event)"
                  @keyup.enter="addTag(addautoBanMsg.keywords, $event)"
                />
              </div>
              <div class="tag-editor-row">
                <span class="hd">封　禁：</span>
                <el-cascader
                  size="mini"
                  v-model="addautoBanMsg.tpl"
                  @change="(e) => banSelChange(e, addautoBanMsg)"
                  :options="banOptions"
                  clearable
                ></el-cascader>
              </div>
            </div>
            <el-popover
              ref="addautoBanMsgTpl"
              placement="bottom-end"
              width="280"
              v-model="isShowInputBlurTips.addautoBanMsgTpl"
              trigger="manual"
              :popper-options="{
                boundariesElement: 'body',
                adaptive: false,
              }"
            >
              <p>记得点“添加”才会生效哦</p>
            </el-popover>
            <el-button size="small" @click="addautoBanMsgTpl" v-popover:addautoBanMsgTpl
              >添加</el-button
            >
          </div>
          <q
            >注意：封禁5分钟是用于玩游戏的，直播间虽显示为30分钟封禁，但在5分钟后会自动解封。</q
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">其他设置</el-col>
        <el-col :span="19">
          <div class="row-padding">
            <el-switch v-model="configure.autoBan.koreanEnable"></el-switch>含有韩文的弹幕
            <el-cascader
              size="mini"
              class="ban-cascader"
              v-model="configure.autoBan.koreanRule[0].tpl"
              @change="(e) => banSelChange(e, configure.autoBan.koreanRule[0])"
              :options="banOptions"
              placeholder="请选择封禁规则"
              clearable
            ></el-cascader>
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.autoBan.japaneseEnable"></el-switch
            >含有日文的弹幕
            <el-cascader
              size="mini"
              class="ban-cascader"
              v-model="configure.autoBan.japaneseRule[0].tpl"
              @change="(e) => banSelChange(e, configure.autoBan.japaneseRule[0])"
              :options="banOptions"
              placeholder="请选择封禁规则"
              clearable
            ></el-cascader>
          </div>
        </el-col>
      </el-row>
      <el-row class="auto-cancel">
        <el-col :span="5">自动解封</el-col>
        <el-col :span="19">
          <div>
            <el-switch v-model="configure.autoBan.autoCancelBanByGiftEnable"></el-switch
            >赠送礼物
            <el-select
              v-model="configure.autoBan.autoCancelBanByGift.giftId"
              @change="autoCancelBanByGiftChange"
              size="mini"
              placeholder="请选择"
            >
              <el-option-group
                v-for="group in giftSelectOptions"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="(groupitem, index) in group.options"
                  :key="index"
                  :label="groupitem.label"
                  :value="groupitem.id"
                ></el-option>
              </el-option-group>
            </el-select>
            <el-input-number
              v-model="configure.autoBan.autoCancelBanByGift.giftCount"
              :controls-position="isPC ? 'right' : ''"
              :min="1"
              size="mini"
              :precision="0"
            ></el-input-number
            >个 自动解封
          </div>
          <div class="row-padding">
            <el-switch v-model="configure.autoBan.autoCancelBan"></el-switch
            >灯牌内容自动解封
          </div>
          <div class="block-tag el-tag--danger">
            灯牌内容带以下关键词的，机器人将自动解除封禁
          </div>
          <div class="tag-editor">
            <div class="tag-editor-row">
              <el-tag
                v-for="(ii, idx) in configure.autoBan.autoCancelBanGiftContentList"
                :key="idx"
                size="small"
                closable
                @close="removeTag(configure.autoBan.autoCancelBanGiftContentList, idx)"
                >{{ ii }}</el-tag
              >
              <input
                type="text"
                placeholder="输入完，按回车确认"
                @blur="addTag(configure.autoBan.autoCancelBanGiftContentList, $event)"
                @keyup.enter="
                  addTag(configure.autoBan.autoCancelBanGiftContentList, $event)
                "
              />
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button type="danger" size="small" @click="resetDefault('自动封禁', 'autoBan')"
          >「自动封禁」恢复默认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { configCommon } from "@/mixins/configCommon";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {
      addautoBanMsg: { keywords: [], tpl: [] },
      banOptions: [
        {
          value: "banChat",
          label: "禁止发言",
          children: [
            {
              value: "5",
              label: "5分钟",
            },
            {
              value: "15",
              label: "15分钟",
            },
            {
              value: "30",
              label: "30分钟",
            },
            {
              value: "1440",
              label: "1天",
            },
            {
              value: "4320",
              label: "3天",
            },
            {
              value: "10080",
              label: "7天",
            },
            {
              value: "43200",
              label: "1月",
            },
            {
              value: "525600",
              label: "1年",
            },
          ],
        },
        {
          value: "blackRoom",
          label: "封入黑名单",
          children: [
            {
              value: "5",
              label: "5分钟",
            },
            {
              value: "15",
              label: "15分钟",
            },
            {
              value: "30",
              label: "30分钟",
            },
            {
              value: "1440",
              label: "1天",
            },
            {
              value: "4320",
              label: "3天",
            },
            {
              value: "10080",
              label: "7天",
            },
            {
              value: "43200",
              label: "1月",
            },
            {
              value: "525600",
              label: "1年",
            },
          ],
        },
        {
          value: "warn",
          label: "警告",
        },
      ],
    };
  },
  props: {
    configure: {
      type: Object,
      default: null,
    },
    featureList: {
      type: Object,
      default: null,
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          duty: true,
          global: true,
        };
      },
    },
    giftSelectOptions: {
      type: Array,
      default: require("@/assets/js/giftSelectOptions.json"),
    },
  },
  mounted() {},
  methods: {
    banSelChange(val, item) {
      console.log(item);
      item.banType = item.tpl[0];
      item.banTime = parseInt(item.tpl[1]) || "";
      this.addautoBanMsgFocusOut();
    }, // 禁言规则改变
    removeAutoBanMsg(index) {
      this.configure.autoBan.rule.splice(index, 1);
      this.$message.success("删除成功");
    }, // 删除智能答复语句
    addautoBanMsgTpl() {
      if (this.addautoBanMsg.keywords.length === 0) {
        this.$message.warning("关键词不能为空哦");
      } else if (this.addautoBanMsg.tpl == "") {
        this.$message.warning("禁言选项不能为空");
      } else {
        this.configure.autoBan.rule.unshift(this.addautoBanMsg);
        this.addautoBanMsg = {
          keywords: [],
          tpl: [],
          banType: "",
          banTime: "",
        };
      }
    }, // 自动禁言添加
    addautoBanMsgFocusOut() {
      if (this.addautoBanMsg.tpl.length) {
        console.log(2);
        setTimeout(() => {
          if (this.addautoBanMsg.keywords.length && this.addautoBanMsg.tpl.length) {
            console.log(13);
            this.eleFocusOut("addautoBanMsgTpl");
          }
        }, 2e3);
      }
    },
    autoCancelBanByGiftChange(e) {
      let index = this.giftSelectOptions[0].options.findIndex((val) => {
        return val.id == e;
      });
      this.configure.autoBan.autoCancelBanByGift.giftName = this.giftSelectOptions[0].options[
        index
      ].label;
    },
  },
};
</script>
